export default __webpack_public_path__ + "static/media/13.292775c9.jpg";